import { useEffect } from "react";
import { useApiError } from "./useApiError";

export const useReportQueryError = (error: unknown) => {
  const { trigger } = useApiError();
  useEffect(() => {
    if (error) trigger(error);
  }, [error, trigger]);
};
